import { supabase } from '@/lib/supabase';

// Helper to manually join products
async function attachProductsToItems(items: any[]) {
  if (!items || items.length === 0) return items;

  const productIds = items.map((item: any) => item.product_id).filter(Boolean);
  if (productIds.length > 0) {
    const { data: productsData } = await supabase
      .from('products')
      .select('_id, name, image')
      .in('_id', productIds);

    if (productsData) {
      items.forEach((item: any) => {
        const prod = productsData.find(p => p._id === item.product_id);
        if (prod) {
          item.products = { name: prod.name, image: prod.image };
        }
      });
    }
  }
  return items;
}

// weekly_picks
export const getWeeklyPicks = async () => {
  const { data, error } = await supabase.from('weekly_picks' as any).select('*').order('id', { ascending: false });
  if (error) throw error;

  return await attachProductsToItems(data);
};

export const createWeeklyPick = async (product_id: number) => {
  const { data, error } = await supabase.from('weekly_picks' as any).insert({ product_id }).select().single();
  if (error) throw error;
  return data;
};

export const deleteWeeklyPick = async (id: number) => {
  const { error } = await supabase.from('weekly_picks' as any).delete().eq('id', id);
  if (error) throw error;
};

// most_viewed
export const getMostViewed = async () => {
  const { data, error } = await supabase.from('most_viewed' as any).select('*').order('views', { ascending: false });
  if (error) throw error;

  return await attachProductsToItems(data);
};

export const createMostViewed = async (product_id: number, views: number = 1) => {
  const { data, error } = await supabase.from('most_viewed' as any).insert({ product_id, views }).select().single();
  if (error) throw error;
  return data;
};

export const updateMostViewed = async (id: number, views: number) => {
  const { data, error } = await supabase.from('most_viewed' as any).update({ views }).eq('id', id).select().single();
  if (error) throw error;
  return data;
};

export const deleteMostViewed = async (id: number) => {
  const { error } = await supabase.from('most_viewed' as any).delete().eq('id', id);
  if (error) throw error;
};

// most_popular
export const getMostPopular = async () => {
  const { data, error } = await supabase.from('most_popular' as any).select('*').order('id', { ascending: false });
  if (error) throw error;

  return await attachProductsToItems(data);
};

export const createMostPopular = async (product_id: number) => {
  const { data, error } = await supabase.from('most_popular' as any).insert({ product_id }).select().single();
  if (error) throw error;
  return data;
};

export const deleteMostPopular = async (id: number) => {
  const { error } = await supabase.from('most_popular' as any).delete().eq('id', id);
  if (error) throw error;
};

// qc_search_history
export const getQCSearchHistory = async () => {
  const { data, error } = await supabase.from('qc_search_history' as any).select('*').order('created_at', { ascending: false });
  if (error) throw error;
  return data;
};

export const createQCSearchHistory = async (query: string, product_name: string, image_url: string) => {
  const { data, error } = await supabase.from('qc_search_history' as any).insert({ query, product_name, image_url }).select().single();
  if (error) throw error;
  return data;
};

export const deleteQCSearchHistory = async (id: number) => {
  const { error } = await supabase.from('qc_search_history' as any).delete().eq('id', id);
  if (error) throw error;
};
